import { Typography } from '@mui/material'
import React from 'react'
import Papa from 'papaparse'
import UploadFileIcon from '@mui/icons-material/UploadFile'

const FileUpload = ({ onFileChange, label, req, setFileName }) => {
  const fileInputRef = React.useRef(null)

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0]
      setFileName(file.name)
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          const jsonResults = results.data
          // console.log('-------jsob',jsonResults);

          // setJsonData(jsonResults)
          onFileChange(jsonResults)
        },
        error: (error) => {
          console.error('Error parsing CSV file:', error)
        },
      })
    } else {
      console.error('No files found in event.target.files')
    }
  }

  const handleChooseFileClick = () => {
    fileInputRef.current.click()
  }

  return (
    <div>
      <Typography className="field-label">
        {label}
        {req && <span className="req">*</span>}
      </Typography>
      <div className={'upload-image'}>
        <div className="selected-file" onClick={handleChooseFileClick}>
          <UploadFileIcon />
        </div>

        <div>
          <div className="choose-file" onClick={handleChooseFileClick}>
            Choose File
          </div>
          <Typography mt={2} color={'#47484981'} className="supported-text">
            Supported file .csv
          </Typography>
        </div>
        <input
          type="file"
          accept=".csv"
          className="input-image"
          onChange={handleFileChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
        />
      </div>
      {/* {jsonData && (
        <pre>
          {JSON.stringify(jsonData, null, 2)}
        </pre>
      )} */}
    </div>
  )
}
export default FileUpload
